const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}`;

const URL_NEW = `${process.env.REACT_APP_API_URL}/query/sp/sp_DashboardNewReturn`;
const URL_APPROVAL = `${process.env.REACT_APP_API_URL}/query/sp/sp_DashboardNeedApproval`;
const URL_COMPLATE = `${process.env.REACT_APP_API_URL}/query/sp/sp_DashboardComplateProsess`;
const URL_PENDING = `${process.env.REACT_APP_API_URL}/query/sp/sp_DashboardpendingProses`;

export const getAll = (payload) => {
  return axios.get(`${URL}/dashboard/return`, {
    params: payload,
  });
};

export const getApproval = (payload) => {
  return axios.get(`${URL}/dashboard/approval`, {
    params: payload,
  });
};

export const getComplate = (payload) => {
  return axios.get(URL_COMPLATE, {
    params: payload,
  });
};
export const getPending = (payload) => {
  return axios.get(URL_PENDING, {
    params: payload,
  });
};
